import { Box, Grid, RadioButton, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { formatPrice } from 'modules/billing/lib/f25Prices'
import { useF25PricingContext } from 'modules/onboarding/components/Pricing/F25PricingContext'
import type Plan from 'modules/onboarding/lib/pricing/plans/Plan'
import { DEFAULT_CURRENCY } from 'modules/onboarding/lib/pricing/plans/utils'

import * as styles from 'modules/billing/components/FactorialF25Bundles/index.vanilla.css'

const BundleSelector = () => {
  const {
    allPlans,
    configPlan,
    setConfigPlan,
    togglePlanSelect,
    period,
    isSelfServedSegment,
    minSeatsToCharge
  } = useF25PricingContext()

  const currency = allPlans.f25Plans[0]?.pricing?.currency || DEFAULT_CURRENCY

  const getPrice = (plan: Plan, showSelfServedPrice: boolean) => {
    const perSeatPrice = plan.pricing.getSeatsPrice(period)
    const totalPrice = perSeatPrice ? perSeatPrice * minSeatsToCharge : 0

    return showSelfServedPrice ? totalPrice : perSeatPrice || 0
  }

  const onChange = (bundle: Plan) => {
    allPlans.f25Plans.forEach((plan) => plan.unselect())
    togglePlanSelect(bundle)
    setConfigPlan({ ...configPlan, planType: bundle.planType })
  }

  return (
    <Grid variant="fixed">
      {allPlans.f25Plans.map((bundle) => (
        <Box key={bundle.internalTitle} gridColSpan={{ xxs: 12, s: 6 }}>
          <Box
            border={{
              all: {
                width: 's2',
                style: 'solid',
                color: bundle.isSelected ? 'viridian1000' : 'grey400'
              }
            }}
            borderRadius={{ all: 'abs008' }}
            background={bundle.isSelected ? 'viridian100' : 'grey000White'}
            padding="s24"
            onClick={() => onChange(bundle)}
          >
            <Box flexDirection="row" justifyContent="spaceBetween" alignItems="flexStart">
              <Box gap="s4">
                <Text.Header2 weight="semibold">{bundle.title}</Text.Header2>
                <Text.Normal size="100" caps weight="bold" color="grey700">
                  {configPlan.planVersion}
                </Text.Normal>
              </Box>
              <RadioButton
                size="medium"
                onChange={() => onChange(bundle)}
                value={bundle.internalTitle}
                checked={bundle.isSelected}
              />
            </Box>
            <Box gap="s4" paddingTop="s16">
              <Text.Header1 className={isSelfServedSegment ? '' : styles.blurredText}>
                {formatPrice(getPrice(bundle, isSelfServedSegment), currency)}
              </Text.Header1>
              <Text size="300" color="grey800">
                {isSelfServedSegment ? (
                  <>{i18n.t('pricing_plans.price_month', { currency })}</>
                ) : (
                  <>{i18n.t('pricing_plans.per_employee_month')}</>
                )}
              </Text>
            </Box>
          </Box>
        </Box>
      ))}
    </Grid>
  )
}

export default BundleSelector
